import React, { useLayoutEffect, useRef, useState } from "react";
import CommentForm from "./CommentForm";
import { usePdfHighlighterContext } from "react-pdf-highlighter-extended";
import "./style/ExpandableTip.css";

import {
  ButtonField,
  Iconsvg,
  TextareaField,
  InputField,
} from "@wk/components-react16";

const ExpandableTip = ({ addHighlight }) => {
  const [compact, setCompact] = useState(true);
  const selectionRef = useRef(null);

  const {
    getCurrentSelection,
    removeGhostHighlight,
    setTip,
    updateTipPosition,
  } = usePdfHighlighterContext();

  useLayoutEffect(() => {
    updateTipPosition();
  }, [compact]);

  return (
    <div className="Tip">
      {compact ? (
        // <button className="Tip__compact">添加评论</button>
        <div
          className="Tip__compact__div"
          onClick={() => {
            setCompact(false);
            selectionRef.current = getCurrentSelection();
            selectionRef.current.makeGhostHighlight();
          }}
        >
          <Iconsvg name="chat-box-plus" size={20} color="#353535" />
        </div>
      ) : (
        <CommentForm
          placeHolder="请输入评论内容"
          onSubmit={(input) => {
            addHighlight(
              {
                content: selectionRef.current.content,
                type: selectionRef.current.type,
                position: selectionRef.current.position,
              },
              input
            );

            removeGhostHighlight();
            setTip(null);
          }}
        />
      )}
    </div>
  );
};

export default ExpandableTip;
